import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import useStyled from "../../hooks/useStyled";

import { ListItem, ListItemButton } from "@mui/material";

import SFTypography from "../typography";

const { styled } = useStyled();

const ListItemButtonStyled = styled(ListItemButton)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  backgroundColor: "transparent",
  "&:hover": {
    color: theme.palette.grey400.main,
  },
}));

const LoadMoreButton = ({ onClick }) => {
  const { t } = useTranslation();
  return (
    <ListItem disablePadding>
      <ListItemButtonStyled disableRipple onClick={onClick}>
        <SFTypography variant="body1">
          {t("components.typeahead.loadMore")}
        </SFTypography>
      </ListItemButtonStyled>
    </ListItem>
  );
};

LoadMoreButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default LoadMoreButton;
